import React from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { myApplicationsListTable, myApplicationTableOptions } from "../../../shared/tableObjects/admin/myApplicationsListTable";
import { PageHeader } from "../../../components/header/PageHeader";
import CreateApplicationButtonsManager from "../../../components/CreateApplicationButtonsManager";

export default function MyApplicationsList() {
  const apiClient = useApiClient("BaseApplication");
  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "My Applications",
      icon: "list-icon",
    },
  ];
  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <CreateApplicationButtonsManager />{" "}
        <Table
          apiClient={apiClient}
          label={""}
          columns={myApplicationsListTable("myapplications")}
          route={"allmy"}
          tableOptions={myApplicationTableOptions}
        />
        <p className="fieldadv mt-0">
          Note: the em dash (—) in the "KPI" column indicates a null value, which indicates the action required is not with the Application team
        </p>
      </div>
    </>
  );
}
